<section class="user-details">
  <div class="container-fluid">
    <div>
      <app-back-button></app-back-button>
      <!-- <button class="backBtn" (click)="goBack()" title="Back">&#8592;</button> -->
      <!-- routerLink="/dashboard/reports" -->
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="auction-content-main mb-4 mb-md-0 position-relative">
          <div class="auction-content-body p-4">
            <ng-container *ngIf="isIndividualAuction">
              <p
                class="auction-status auction-status--online"
                *ngIf="!approveRequire && approveStatus"
              >
                Approved
              </p>
              <p
                class="auction-status auction-status--offline"
                *ngIf="approveRequire && approveStatus === false"
              >
                Rejected
              </p>
              <div class="user-details__user border-bottom py-4">
                <div class="user-details__userThumb mr-2">
                  <img src="{{ getImageUrl }}" alt="" />
                </div>
                <div class="user-details__userInfo">
                  <h3 class="heading-tertiary mb-1">
                    {{ getTitle || productData?.title }}
                  </h3>
                  <h3 class="fs-normal color-gray d-flex align-items-center">
                    <i class="las la-map-marker-alt ion-lg mr-1"></i>
                    {{ allData?.location ? allData?.location : "N/A" }}
                  </h3>
                </div>
              </div>

              <div class="user-details__credentials border-bottom py-4">
                <div class="container">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled auctionCarInfo__listKeyList">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Reserve Price:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Reserve Bid:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Opening Price:</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            SAR {{ allData?.lowest_price }}
                          </span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.buy_now_price ? "YES" : "NO" }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues"
                            >SAR {{ allData?.opening_price }}</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Buy Now Price:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Increment Price:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Color:</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            SAR {{ allData?.buy_now_price }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues"
                            >SAR {{ allData?.incremental_price }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.description_data ? allData?.description_data?.["Interior Colour"] :
                            allData?.bulkInfo?.[0]?.ProductInfo[0]?.description_data?.["Interior Colour"] }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="user-details__credentials py-4">
                <div class="container">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled auctionCarInfo__listKeyList">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Body Type:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Interior:</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Exterior:</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Stock Number:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">VIN:</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Body Type"] :
                            allData?.description_data?.["Body Type"] }}
                          </span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Interior Colour"] :
                            allData?.description_data?.["Interior Colour"] }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Exterior Colour"] :
                            allData?.description_data?.["Exterior Colour"] }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues"
                            >57576766</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["VIN Number"] :
                            allData?.description_data?.["VIN Number"]
                          }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Engine:</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Transmission:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Drive Type:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Fuel Type:</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Engine Type"] :
                            allData?.description_data?.["Engine Type"] }}
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Cylinders"] :
                            allData?.description_data?.["Cylinders"] }}
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["HP (Horse Power)"] :
                            allData?.description_data?.["HP (Horse Power)"] }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ allData?.auction_type === "1"
                            ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Transmission Type"] :
                            allData?.description_data?.["Transmission Type"] }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            allData?.auction_type === "0"
                            ? allData?.ProductInfo?.[0].description_data?.["DriveType"] :
                            allData?.description_data?.["DriveType"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            allData?.auction_type === "0"
                            ? allData?.ProductInfo?.[0].description_data?.["DriveType"] :
                            allData?.description_data?.["FuelType"]
                          }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="auction-dt-tableTool">
                    <div
                      class="auction-dt-tableTool"
                      *ngIf="approveRequire && approveStatus === null"
                    >
                      <button
                        type="button"
                        class="btn btn__main curved green px-4 mr-2"
                        [disabled]="approveStatus"
                        (click)="updateStatus(activroute, '1')"
                      >
                        Approve
                      </button>
                      <button
                        type="button"
                        class="btn btn__main curved red px-4 mr-2"
                        *ngIf="
                          approveStatus === false || approveStatus === null
                        "
                        [disabled]="approveStatus === false"
                        (click)="updateStatus(activroute, '0')"
                      >
                        Reject
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn__main curved"
                        routerLink="/dashboard/auction/edit/{{
                          activroute
                        }}"
                        [queryParams]="{ type: queryParam }"
                      >
                        View Auction
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="isBatchAuction || isBulkAuction">
              <ng-container *ngFor="let vehicle of vehicles; index as i">
                <div class="row mb-2" (click)="renderVehicleDetails(vehicle)">
                  <div class="col bg-secondary car-list">
                    <div class="row">
                      <div class="col-md-3">
                        <img
                          class="car-image"
                          src="{{ vehicle['frontImg'] || getImageUrl }}"
                          alt=""
                        />
                      </div>
                      <div class="col-md-6">
                        {{ vehicle["vehicleName"] }}
                      </div>
                      <div class="col-md-3">
                        <a
                          [routerLink]="[
                            '/dashboard/inventory/vehicle-details',
                            vehicle['product_id']
                          ]"
                          class="auction-bidders"
                        >
                          <ion-icon
                            name="eye"
                            class="ion-lg color-yellow"
                          ></ion-icon>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="user-details__credentials border-bottom py-4">
                <div class="container">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled auctionCarInfo__listKeyList">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Reserve Price:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Reserve Bid:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Opening Price:</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            SAR {{ currentAuction["lowest_price"] }}
                          </span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{
                              currentAuction["buy_now_price"] ? "YES" : "NO"
                            }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues"
                            >SAR {{ currentAuction["opening_price"] }}</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Buy Now Price:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Increment Price:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Color:</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            SAR {{ currentAuction?.['buy_now_price'] }}</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues"
                            >SAR {{ currentAuction?.['incremental_price'] }}
                          </span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">
                            {{ currentAuction?.['description_data'] ?
                            currentAuction?.['description_data']?.["Interior Colour"] :
                            currentAuction?.['bulkInfo']?.[0]?.ProductInfo[0]?.description_data?.["Interior Colour"] }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Render Vehicle Details -->
            <ng-container *ngIf="showVehicleDetails">
              <div class="user-details__credentials py-4">
                <div class="container">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled auctionCarInfo__listKeyList">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Body Type:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Interior:</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Exterior:</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Stock Number:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">VIN:</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Body Type"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Interior Colour"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Exterior Colour"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues"
                            >57576766</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["VIN Number"]
                          }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey">Engine:</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Transmission:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Drive Type:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Fuel Type:</span
                          >
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listKey"
                            >Horse Power:</span
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                      <ul class="list-unstyled">
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Engine Type"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Cylinders"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Drive Type"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["Fuel Type"]
                          }}</span>
                        </li>
                        <li class="mt-2">
                          <span class="auctionCarInfo__listValues">{{
                            vehicleDetails["HP (Horse Power)"]
                          }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="auction-dt-tableTool">
                    <div
                      class="auction-dt-tableTool"
                      *ngIf="approveRequire && approveStatus === null"
                    >
                      <button
                        type="button"
                        class="btn btn__main curved green px-4 mr-2"
                        [disabled]="approveStatus"
                        (click)="updateStatus(activroute, '2')"
                      >
                        Approve
                      </button>
                      <button
                        type="button"
                        class="btn btn__main curved red px-4 mr-2"
                        *ngIf="
                          approveStatus === false || approveStatus === null
                        "
                        [disabled]="approveStatus === false"
                        (click)="updateStatus(activroute, '0')"
                      >
                        Reject
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn__main curved"
                        routerLink="/dashboard/auction/edit/{{
                          activroute
                        }}"
                        [queryParams]="{ type: queryParam }"
                      >
                        View Auction
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-container *ngIf="bidHistoryData.length">
        <div class="col-md-6 auction-content-main">
          <tabset>
            <tab heading="Bid History">
              <div>
                <div class="auction-content-body p-4">
                  <div class="timeLineBox">
                    <ul class="list-unstyled timeLine">
                      <li
                        class="timeLine__item"
                        *ngFor="let bidHistory of bidHistoryData; index as i"
                      >
                        <div class="timeLine__date px-2">
                          {{dateFormatter(bidHistory?.['created_at'])}}
                        </div>
                        <div class="timeLine__data flex-column">
                          <h5
                            class="fs-sm fw-600 mb-1 text-capitalize"
                            *ngIf="bidHistory['first_name']"
                          >
                            {{ bidHistory["first_name"] }}
                            {{ bidHistory["last_name"] }}
                          </h5>
                          <h5 class="fs-sm fw-600 mb-0">
                            BID: SAR {{ bidHistory["Bidding_amount"] }}
                          </h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </tab>

            <tab heading="Documents">
              <div *ngIf="paymentDoc?.length; else noDocument">
                <div class="auction-content-body p-4">
                  <div class="timeLineBox">
                    <ul class="list-unstyled timeLine">
                      <ng-container
                        *ngFor="let document of paymentDoc; index as i"
                      >
                        <li class="timeLine__item">
                          <div
                            class="
                              timeLine__data
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <div class="d-flex flex-column align-items-start">
                              <h5 class="fs-sm fw-600 mb-1 text-capitalize">
                                {{ document["document_name"] }}
                              </h5>
                              <p class="m-0">
                                {{
                                  document["created_at"]
                                    | date: "MMM d, y, h:mm a"
                                }}
                              </p>
                            </div>

                            <div>
                              <button
                                type="button"
                                class="btn curved yellow mr-2 rounded"
                                style="width: fit-content"
                                (click)="
                                  viewPaymentDoc(
                                    document['imageUrl']['presigned_url']
                                  )
                                "
                              >
                                View
                              </button>

                              <button
                                *ngIf="
                                  document['payment_doc_status'] === null ||
                                  document['payment_doc_status'] === true
                                "
                                type="button"
                                class="
                                  btn btn-success
                                  paymentActionBtnGroup
                                  mr-2
                                "
                                [disabled]="document['payment_doc_status']"
                                (click)="
                                  updatePaymentDocStatus(
                                    1,
                                    i,
                                    document['doc_id'],
                                    document['document_name']
                                  )
                                "
                              >
                                {{
                                  document["payment_doc_status"] === true
                                    ? "Approved"
                                    : "Approve"
                                }}
                              </button>

                              <button
                                *ngIf="
                                  document['payment_doc_status'] === null ||
                                  document['payment_doc_status'] === false
                                "
                                type="button"
                                class="btn btn-danger paymentActionBtnGroup"
                                [disabled]="
                                  document['payment_doc_status'] === false
                                "
                                (click)="
                                  openRejectWhyModal(
                                    rejectReasonModal,
                                    i,
                                    document['doc_id'],
                                    document['document_name']
                                  )
                                "
                              >
                                {{
                                  document["payment_doc_status"] === false
                                    ? "Rejected"
                                    : "Reject"
                                }}
                              </button>
                            </div>
                          </div>
                        </li>
                      </ng-container>

                      <ng-container *ngIf="paymentDocStaus">
                        <ng-container
                          *ngFor="
                            let doc of globalDocsObj | keyvalue;
                            index as i
                          "
                        >
                          <li class="timeLine__item">
                            <div
                              class="
                                timeLine__data
                                d-flex
                                align-items-center
                                justify-content-between
                              "
                            >
                              <div class="d-flex flex-column align-items-start">
                                <h5 class="fs-sm fw-600 mb-1 text-capitalize">
                                  {{ doc["key"] }}
                                </h5>
                                <p
                                  *ngIf="doc['value']['available']"
                                  class="fs-normal fw-300 m-0"
                                >
                                  {{
                                    doc["value"]["uploadTime"]
                                      | date: "MMM d, y, h:mm a"
                                  }}
                                </p>
                                <input
                                  *ngIf="!doc['value']['available']"
                                  class="mb-2"
                                  type="file"
                                  accept="image/jpeg,image/jpg,image/png, .pdf"
                                  (change)="getDocument($event, doc['key'])"
                                />
                              </div>

                              <div class="">
                                <button
                                  *ngIf="!doc['value']['available']"
                                  class="btn curved yellow rounded"
                                  [disabled]="!doc['value']['enableUpload']"
                                  [ladda]="laddaBtns[i]"
                                  (click)="
                                    uploadDocument(activroute, doc['key'], i)
                                  "
                                  title="Upload {{ doc['key'] }}"
                                >
                                  Upload
                                </button>
                                <button
                                  *ngIf="doc['value']['available']"
                                  class="ml-2 btn curved yellow rounded"
                                  (click)="
                                    viewInvoice(doc['value']['imageUrl'])
                                  "
                                  title="View {{ doc['key'] }}"
                                >
                                  View
                                </button>
                                <button
                                  [disabled]="!doc['value']['available']"
                                  class="ml-2 btn curved red rounded"
                                  [ladda]="laddaBtns[i]"
                                  (click)="
                                    deleteAdminDoc(
                                      activroute,
                                      doc['value']['id'],
                                      doc['key'],
                                      i
                                    )
                                  "
                                  title="Delete {{ doc['key'] }}"
                                >
                                  Delete
                                </button>
                              </div>
                            </div>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </div>

              <ng-template #noDocument>
                <h3>No document yet!</h3>
              </ng-template>
            </tab>

            <tab heading="Return Request">
              <p>Coming soon</p>
            </tab>
          </tabset>
        </div>
      </ng-container>
    </div>
  </div>
</section>
<app-loader *ngIf="loading"></app-loader>

<!-- Reject Reason Modal -->
<ng-template #rejectReasonModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left p-0 fs-lg">Why reject?</h4>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden"
        ><ion-icon name="close-outline"></ion-icon
      ></span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <textarea
        class="w-100 border reject-txt-area p-2 text-dark"
        cols="30"
        rows="10"
        [(ngModel)]="whyReject"
        placeholder="Please describe why document is rejected"
      ></textarea>
      <div class="d-flex flex-row-reverse mt-2">
        <button
          class="btn curved yellow rounded ml-2"
          [ladda]="rejectLaddaBtn"
          (click)="onSubmitReject()"
        >
          Submit
        </button>
        <button class="btn curved gray rounded" (click)="modalRef?.hide()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
